import React from 'react';
import TreeBranch from './TreeBranch.js';
export function Tree(props) {
    const { data, dataMetrics, dataTestId } = props;
    return (React.createElement("ul", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'tree', className: "twds-mb-4 twds-font-lato twds-list-none" }, data.map((item) => (React.createElement(TreeBranch, { key: item.id, item: item, level: 0 })))));
}
//# sourceMappingURL=Tree.js.map